export default __webpack_public_path__ + "static/media/Slagtere på JAKA-fabrikken.4864b0fc.jpg";